module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "data-source-step__target-name"
  }, [_vm._v("\n      " + _vm._s(_vm.targetName) + "\n    ")]), _vm._v(" "), _c('select-data-source', {
    model: {
      value: (_vm.selectedDataSource),
      callback: function($$v) {
        _vm.selectedDataSource = $$v
      },
      expression: "selectedDataSource"
    }
  })], 1), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd2262e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/stepper/DataSourceStep.vue
// module id = 2577
// module chunks = 0